import { render, staticRenderFns } from "./DesfazerTrocaTitularidade.vue?vue&type=template&id=017bcfa2&"
import script from "./DesfazerTrocaTitularidade.vue?vue&type=script&lang=js&"
export * from "./DesfazerTrocaTitularidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports